module.exports = __webpack_public_path__ + "ef83287f93e52a95f25290378abbee5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/category-headers/marketing_promotion.svg
// module id = 1932
// module chunks = 0